import { useContext } from 'react'
import { AuthContext } from '../providers/authProvider'

export const useAuth = () => {
  const {
    isLogged,
    logIn,
    signOut,
    currentUser,
    verificarPermissao,
    verificarSetor,
    getProfile,
    permissoesUsuario,
    loginErro,
    socket,
  } = useContext(AuthContext)

  return {
    isLogged,
    logIn,
    signOut,
    currentUser,
    getProfile,
    verificarPermissao,
    verificarSetor,
    permissoesUsuario,
    loginErro,
    socket,
  }
}
